module.exports = __webpack_public_path__ + "img/activity_courier.3d42784e.png";